import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Brand } from '../models/brand.model';



@Injectable({
  providedIn: 'root'
})
export class BrandService {

  private http = inject(HttpClient);

  private apiUrl =
    `${environment.apiBaseUrl}/Brands`;


  getBrands(): Observable<any> {

    return this.http.get<any>(
      this.apiUrl
    );

  }


  getBrand(id: number): Observable<Brand> {

    return this.http.get<Brand>(
      `${this.apiUrl}/${id}`
    );

  }

}